<i18n src="@/locales/modules/DepartmentTranslate.json"></i18n>

<template>
	<CbsContextMenu
		v-if="department.can_delete || department.can_update || mixinIsCanCreateTitle"
		v-bind="$attrs"
		:class="['department-context-menu', { 'mr-5': displayMode === 'detail' }]"
		:menuListDataBinding="{ class: 'department-context-menu-list' }"
	>
		<div v-if="mixinIsCanCreateTitle" class="department-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickManageTitle', department)">
			<i class="nucleo mr-3 nucleo-badge-14-2" />
			{{ $t("Title") }}
		</div>
		<div v-if="department.can_update" class="department-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickEdit', department)">
			<i class="nucleo mr-3 nucleo-edit" />
			{{ $t("Actions.Edit") }}
		</div>

		<div v-if="department.can_delete" class="department-context-menu-list__item pr-16 text-black flex items-center whitespace-no-wrap" @click="$emit('onClickDelete', department)">
			<i class="nucleo mr-3 nucleo-trash-can" />
			{{ $t("Actions.Delete") }}
		</div>
	</CbsContextMenu>
	<span v-else></span>
</template>

<script>
import { titlePermissions, departmentPermissions, getUserPermissions } from "@/mixins/mixins.js";

import CbsContextMenu from "@/components/cbs-context-menu/CbsContextMenu";

export default {
	name: "DepartmentContextMenu",
	mixins: [
		getUserPermissions({
			...departmentPermissions,
			...titlePermissions
		})
	],
	components: { CbsContextMenu },
	props: {
		department: {
			type: Object,
			required: true
		},
		displayMode: {
			type: String,
			default: "list",
			validator: prop => ["list", "detail"].includes(prop)
		}
	},
	emits: {
		onClickEdit: {},
		onClickDelete: {},
		onClickManageTitle: {}
	}
};
</script>

<style lang="scss" scoped>
.department-context-menu {
	&.cbs-context-menu--horizontal ::v-deep .cbs-context-menu__btn-trigger {
		color: var(--color-gray-4);
	}
}

.department-context-menu-list {
	.department-context-menu-list__item {
		font-size: 14px;

		i {
			font-size: 18px;
		}
	}
}
</style>
